import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import i18nNewlineToBr from "./i18nNewlineToBr";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(i18nNewlineToBr)
  .init({
    fallbackLng: "de",
    debug: false, // useful for debugging

    // Preload only the essential namespaces
    ns: ["common", "navbar", "footer"],
    defaultNS: "common",

    interpolation: {
      escapeValue: true, // React already protects from XSS
    },
    postProcess: ['newlineToBr'],

    react: {
      useSuspense: false,  // ✅ disable React Suspense
    },

    backend: {
      // 👇 Translation file path
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      parse: (data, ns) => JSON.parse(data),
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag", "cookie", "path"],
      caches: ["localStorage"],
    },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
  localStorage.setItem("lang", lng);
});

export default i18n;